import React, { memo } from 'react';
import { Popup } from 'react-leaflet';
import TitleSubtitle from '../TitleSubtitle';
import { getDayMonthNameYearTime, getDistanceDate } from '../../helpers/dateHelper';

const textSx = { mb: 1 };

const shouldMemo = (
  prevProps,
  nextProps,
) => prevProps?.vehicle?.place?.x === nextProps?.vehicle?.place?.x;

const NO_VALUE = 'Нет данных';

export const VehiclePopup = memo(({ vehicle }) => (
  <Popup>
    <TitleSubtitle
      sx={textSx}
      title="Дата и время фиксации"
      subTitle={getDayMonthNameYearTime(vehicle.time || vehicle.created_at) || 'Нет даты у точки'}
    />
    <TitleSubtitle
      sx={textSx}
      title="Продолжительность стоянки"
      subTitle={getDistanceDate(vehicle.time || vehicle?.navigationTime) || NO_VALUE}
    />
    <TitleSubtitle sx={textSx} title="ЕГРЗ ТС (Номер ТС)" subTitle={vehicle.egrz || vehicle?.stateNumber || NO_VALUE} />
    <TitleSubtitle
      sx={textSx}
      title="Марка и модель ТС:"
      subTitle={`${vehicle.brand ? `${vehicle.brand} ` : ''}${vehicle.model || ''}`.trim() || NO_VALUE}
    />
    <TitleSubtitle sx={textSx} title="Скорость" subTitle={vehicle.velocity ?? NO_VALUE} />
    <TitleSubtitle
      title="Координаты"
      subTitle={vehicle.place?.x !== undefined ? `${vehicle.place?.x} ${vehicle.place?.y}` : NO_VALUE}
    />
  </Popup>
), shouldMemo);
